import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient, NAV_URL } from "../config/develop-config";

const baseUrl = `${BASE_URL}/auth`;

const getTeamInRule = async (company: string) => {
  return await httpClient
    .get(`${baseUrl}/over-credit-approval-rule/team-shop-count/${company}`)
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const getAllRule = async (company: string) => {
  return await httpClient
    .get(`${baseUrl}/over-credit-approval-rule/get-list/${company}`)
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const deleteRule = async (ruleId: string, updateBy: string) => {
  return await httpClient
    .delete(`${baseUrl}/over-credit-approval-rule/delete-rule/${ruleId}/${updateBy}`)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const getApproveDetail = async (ruleConditionsId: string) => {
  return await httpClient
    .get(`${baseUrl}/over-credit-approval-rule/get-approval-details/${ruleConditionsId}`)
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const getRuleById = async (ruleId: string) => {
  return await httpClient
    .get(`${baseUrl}/over-credit-approval-rule/get-rule-detail/${ruleId}`)
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const createAdvanceCreditSetting = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/over-credit-approval-rule/create-rule`, data)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const updateAdvanceCreditSetting = async (data: any) => {
  return await httpClient
    .patch(`${baseUrl}/over-credit-approval-rule/update-rule/${data.ruleId}`, data)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const getShopDetailInRule = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/over-credit-approval-rule/get-customer-company`, params)
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const getRuleEachShop = async (company: string) => {
  return await httpClient
    .get(`${baseUrl}/over-credit-approval-rule/get-all-rules/${company}`)
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const getAllRuleEachShop = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/over-credit-approval-rule/shop-rule-list`, { params })
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const updateRuleEachShop = async (data: any) => {
  return await httpClient
    .patch(
      `${baseUrl}/over-credit-approval-rule/shop-customization/${data.ruleCustomerCompanyId}`,
      data,
    )
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const updateStatusEachShop = async (data: any) => {
  return await httpClient
    .patch(`${baseUrl}/over-credit-approval-rule/shop-status/${data.ruleCustomerCompanyId}`, data)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const createRuleEachShop = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/over-credit-approval-rule/shop-customization`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const getShopSameCondition = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/over-credit-approval-rule/customer-company-list`, { params })
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const createShopSameCondition = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/over-credit-approval-rule/same-conditions-rule-shop`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const deleteRuleEachShop = async (params: object) => {
  return await httpClient
    .delete(`${baseUrl}/over-credit-approval-rule/shop-rule`, { params })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const checkChangeLimitCredit = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/over-credit-approval-rule/shops-custom-percent-exceed`, { params })
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const updateShopWithNewCreditLimit = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/over-credit-approval-rule/bulk-reset-shops-to-rule`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

export {
  createAdvanceCreditSetting,
  getTeamInRule,
  getAllRule,
  deleteRule,
  getApproveDetail,
  getRuleById,
  updateAdvanceCreditSetting,
  getShopDetailInRule,
  getRuleEachShop,
  getAllRuleEachShop,
  updateRuleEachShop,
  updateStatusEachShop,
  createRuleEachShop,
  getShopSameCondition,
  createShopSameCondition,
  deleteRuleEachShop,
  checkChangeLimitCredit,
  updateShopWithNewCreditLimit,
};
